import { MODE_APPOINTMENT } from 'client-portal/utils/prescreener/constants';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Controller from '@ember/controller';

export default class RequestPrescreenerBaseCategoryController extends Controller {
  @service currentPractice;
  @service prescreener;
  @service session;

  get modeAppointment() {
    return MODE_APPOINTMENT;
  }

  @action
  onSubmit() {
    this.nextStep?.();
  }
}
